import config from '@/config/config';
import mutations from './antagonist/mutations';
import actions from './antagonist/actions';
import getters from './antagonist/getters';

const code = {
  namespaced: true,
  state: {
    isLoading: false,
    token: null,
    course: {},
    errors: [],
    exam: {},
    answers: [],
    examResults: {},
    current: config.initial.course.start,
    currentCourse: config.initial.course.start,
    currentLectureIndex: 0,
  },
  getters,
  mutations,
  actions,
};

export default code;
